import { memo } from "react"
import { fontType, main } from "../assets/extras";
import { IoClose } from "react-icons/io5";
import { decomposeDate, formatedNumber } from "../assets/validator";

const BalanceModal = ({
    variables,
    setVariables,
    generateXLSX
}) => {

    return (
        <div>
            {variables.showBalance && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            width: "80%",
                            maxWidth: 600,
                            height: 400,
                            borderRadius: 20,
                            padding: 20,
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            overflowY: "scroll"
                        }}
                    >

                        <IoClose
                            size={24}
                            color="red"
                            style={{
                                position: "absolute",
                                top: 15,
                                right: 15,
                                cursor: "pointer"
                            }}
                            onClick={() =>
                                setVariables(prev => ({
                                    ...prev,
                                    showBalance: false
                                }))
                            }
                        />

                        <h2
                            style={{
                                fontSize: 25,
                                fontWeight: "bold",
                                marginBottom: 20,
                                width: "100%",
                                textAlign: "center",
                                fontFamily: fontType.title,
                                color: "black",
                                borderBottom: "1px solid black"
                            }}
                        >
                            BALANCE GENERAL
                        </h2>

                        <div style={{
                            marginBottom: 20
                        }}>
                            {
                                variables.sumaPorDias.length > 0 ?
                                    variables.sumaPorDias.map((v, i) => {
                                        return (
                                            <div style={{
                                                backgroundColor: "#f5f6f7",
                                                borderRadius: 10,
                                                marginBottom: 10,
                                                padding: 10,
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column"
                                            }}>
                                                <h4 style={{
                                                    fontFamily: fontType.title,
                                                    borderBottom: "1px solid #ccc",
                                                    width: "100%",
                                                    textAlign: "center"
                                                }}>{decomposeDate(v.fecha)}</h4>
                                                <div style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-evenly",
                                                    marginTop: 10
                                                }}>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                        <p style={{
                                                            fontFamily: fontType.text,
                                                            fontWeight: "bold"
                                                        }}>INGRESOS</p>
                                                        <p style={{
                                                            fontFamily: fontType.text,
                                                        }}>${formatedNumber(parseInt(v.totalIngresos))}</p>
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                        <p style={{
                                                            fontFamily: fontType.text,
                                                            fontWeight: "bold"
                                                        }}>EGRESOS</p>
                                                        <p style={{
                                                            fontFamily: fontType.text,
                                                        }}>${formatedNumber(parseInt(v.totalEgresos))}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                : null
                            }
                        </div>

                        <p style ={{
                            fontFamily: fontType.text
                        }}><span style={{
                            fontFamily: fontType.title
                        }}>Total ingresos: </span>${formatedNumber(parseInt(variables.totalIngresos))}</p>
                        <p style ={{
                            fontFamily: fontType.text
                        }}><span style={{
                            fontFamily: fontType.title
                        }}>Total egresos: </span>${formatedNumber(parseInt(variables.totalEgresos))}</p>

                        <div style={{
                            borderTop: "1px solid black",
                            paddingTop: 20
                        }}>
                            <p style={{
                                fontFamily: fontType.text,
                                fontSize: 25, 
                            }}>
                                <span style={{
                                    fontFamily: fontType.title
                                }}>TOTAL: </span>
                                ${formatedNumber(parseInt(variables.totalIngresos) - parseInt(variables.totalEgresos))}
                            </p>
                        </div>

                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: 20
                        }}>
                            <button style={{
                                width: "60%",
                                minWidth: 150,
                                padding: 10,
                                backgroundColor: "black",
                                border: "none",
                                borderRadius: 10,
                                color: "white",
                                fontFamily: fontType.title,
                                fontSize: 18
                            }} onClick={generateXLSX}>GENERAR XLSX</button>
                        </div>

                    </div>
                </div>
            )
        }
        </div>
    )
}

export default memo(BalanceModal)